import React from 'react'
import PropTypes from 'prop-types'
import { Panel, ListGroup, ListGroupItem } from 'react-bootstrap'
import { rest, utils } from '../../lib'

class SiteInfo extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      sitename: '',
      description: '',
      siteaddress: '',
      sitecapacity: '',
      sitefacility: '',
      siteopen: '',
      model: '',
      uptime: 0,
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.fetchInfo()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  fetchInfo = () => {
    //rest.deviceList().then(() =>{})
    rest.getSite()
    .then(resp => {
      if (resp.status === 'success' && this._isMounted) {
        this.setState({
          sitename: resp.sitename,
          description: resp.description,
          siteaddress: resp.siteaddress,
          sitecapacity: resp.sitecapacity,
          sitefacility: resp.sitefacility,
          siteopen: resp.siteopen,
          model: resp.model,
          uptime: resp.uptime
        })
      }
    })
  }

  siteInfo = () => {
    const { sitename, description, siteaddress, sitecapacity, siteopen, model, uptime } = this.state
    const rows = []
    let i = 0
    rows.push(<ListGroupItem key={i++} header={sitename || ''}><span className='text-sm'>SITE ID</span></ListGroupItem>)
    rows.push(<ListGroupItem key={i++} header={description || ''}>DESCRIPTION</ListGroupItem>)
    rows.push(<ListGroupItem key={i++} header={siteaddress || ''}>ADDRESS</ListGroupItem>)
    rows.push(<ListGroupItem key={i++} header={sitecapacity || ''}>CAPACITY</ListGroupItem>)
    rows.push(<ListGroupItem key={i++} header={siteopen || ''}>DATE OF SUBSCRIPTION</ListGroupItem>)
    rows.push(<ListGroupItem key={i++} header={model || ''}>MODEL</ListGroupItem>)
    rows.push(<ListGroupItem key={i++} header={utils.ellapsed(uptime)}>UPTIME</ListGroupItem>)
    return rows
  }

  render() {
    const { strings } = this.props
    return (
      <Panel bsStyle='info' header={strings.siteinfo}>
        <ListGroup bsClass='list-group text-center' fill>
          {this.siteInfo()}
        </ListGroup>
      </Panel>
    )
  }
}

SiteInfo.propTypes = {
  strings: PropTypes.object
}

SiteInfo.defaultProps = {
  strings: {
    siteinfo: 'Site Information'
  }
}

export default SiteInfo



// WEBPACK FOOTER //
// ./src/components/widgets/SiteInfo.js